import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-set-signature-info',
  templateUrl: './set-signature-info.component.html',
  styleUrls: ['./set-signature-info.component.scss'],
})
export class SetSignatureInfoComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
